import { Row } from '@tanstack/react-table';

import {
  DeductionsReportBulkActions,
  IndividualBulkActions,
  IndividualType,
  PayCalendarBulkActions,
  SuspiciousTransactionBulkActions,
} from 'app/components/UI/Table/Table.types';

import { getIndividualBulkActionsValues } from './individuals';
import { getPayCalendarBulkActionsValues } from './payCalendars';
import { getDeductionsReportBulkActionsValues } from './deductionsReports';
import { getSuspiciousTransactionBulkActionsValues } from './suspiciousTransactions';

export function getBulkActionsValues<TData extends object>(
  type: IndividualType | 'payCalendar' | 'deductionsReport' | 'suspiciousTransaction',
  actions:
    | IndividualBulkActions
    | PayCalendarBulkActions
    | DeductionsReportBulkActions
    | SuspiciousTransactionBulkActions,
  selectedRows: Row<TData>[]
) {
  switch (type) {
    case 'admin':
    case 'employee':
      return getIndividualBulkActionsValues(type, actions as IndividualBulkActions, selectedRows);
    case 'payCalendar':
      return getPayCalendarBulkActionsValues(actions as PayCalendarBulkActions, selectedRows);
    case 'deductionsReport':
      return getDeductionsReportBulkActionsValues(
        actions as DeductionsReportBulkActions,
        selectedRows
      );
    case 'suspiciousTransaction':
      return getSuspiciousTransactionBulkActionsValues(
        actions as SuspiciousTransactionBulkActions,
        selectedRows
      );
    default:
      return { label: '', bulkActions: [] };
  }
}

export default getBulkActionsValues;
